import { AxiosError, AxiosPromise, AxiosResponse } from 'axios'
import { AnyAction, Dispatch } from 'redux'

import { ITikTokAuth, ITikTokBusinessCenter, TikTokActionTypes } from './types'

import { API_URL } from '@/const'
import { ThunkResult } from '@/store/store'
import { UserActionTypes } from '@/store/user/types'
import { customAxios } from '@/utils'

export function setStep(step: number): AnyAction {
  return { type: TikTokActionTypes.SET_TIKTOK_STEP, data: step }
}

export function setTikTokAccessToken(body: ITikTokAuth): ThunkResult<Promise<any>> {
  return (dispatch: Dispatch) => {
    dispatch({ type: TikTokActionTypes.SET_TIKTOK_AUTH_LOADING, data: true })
    dispatch({ type: TikTokActionTypes.SET_TIKTOK_AUTH_ERROR, data: false })

    return customAxios(`${API_URL}/me/tiktok_credentials/`, 'POST', body, true)
      .then((response: AxiosResponse<ITikTokAuth>): any => {
        dispatch({ type: UserActionTypes.SET_TIKTOK_CREDENTIAL, data: true })
        dispatch({ type: TikTokActionTypes.SET_TIKTOK_AUTH_CODE, data: body.auth_code })

        return response
      })
      .catch((error: AxiosError) => {
        dispatch({ type: TikTokActionTypes.SET_TIKTOK_AUTH_ERROR, data: true })

        return Promise.reject(error)
      })
      .finally(() => {
        dispatch({ type: TikTokActionTypes.SET_TIKTOK_AUTH_LOADING, data: false })
      })
  }
}

export function getBusinessCenters(): ThunkResult<AxiosPromise<any>> {
  return (dispatch: Dispatch) => {
    dispatch({ type: TikTokActionTypes.SET_TIKTOK_BUSINESS_CENTERS_LOADING, data: true })

    return customAxios(`${API_URL}/tiktok/business_centers/`, 'GET', null, true)
      .then((response: AxiosResponse<ITikTokBusinessCenter[]>): any => {
        dispatch({
          type: TikTokActionTypes.SET_TIKTOK_BUSINESS_CENTERS,
          data: response.data,
        })
        return response
      })
      .catch((error: AxiosError) => Promise.reject(error))
      .finally(() => {
        dispatch({ type: TikTokActionTypes.SET_TIKTOK_BUSINESS_CENTERS_LOADING, data: false })
      })
  }
}

export function setErrors(errors: any): AnyAction {
  return { type: TikTokActionTypes.SET_TIKTOK_ERRORS, data: errors }
}

export function setRedirect(route: string): AnyAction {
  return { type: TikTokActionTypes.SET_TIKTOK_REDIRECT, data: route }
}
